import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./assets/stylesheets/index.css";
import KeycloakManager from "./services/keycloak.ts";
import { getThemeConfig } from "./services/theme.ts";

import { Provider } from "react-redux";
import { store } from "./store/index.ts";
import { setConfig, type AppThemeConfigState } from "./store/appConfigSlice.ts";

const container = document.getElementById("root")!;
const root = createRoot(container);

function applyThemeVariables(config: AppThemeConfigState) {
  const shellBackgroundColor = config.appBackgroundColor;

  const setThemeVariable = (name: string, value?: string) => {
    if (value) {
      document.documentElement.style.setProperty(name, value);
    }
  };

  setThemeVariable("--app-background-color", shellBackgroundColor);
  setThemeVariable(
    "--app-header-background-color",
    config.headerBackgroundColor ?? shellBackgroundColor,
  );
  setThemeVariable(
    "--app-sidebar-background-color",
    config.sidebarBackgroundColor ?? shellBackgroundColor,
  );
  setThemeVariable(
    "--app-header-foreground-color",
    config.headerForegroundColor ?? config.shellForegroundColor,
  );
  setThemeVariable(
    "--app-sidebar-foreground-color",
    config.sidebarForegroundColor ?? config.shellForegroundColor,
  );
}

async function init() {
  await KeycloakManager.initKeycloak(store.dispatch);

  try {
    const config = await getThemeConfig();
    store.dispatch(setConfig(config));
    applyThemeVariables(config);
  } catch (err) {
    console.error("Error loading theme configuration:", err);
  }

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

init();
